var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-search"},[_c('div',{attrs:{"id":"poi_box","placeholder":"请输入关键字选取地点"}})])}]

export { render, staticRenderFns }